import './_GlobalStyles.scss'

export type ReactNodeChilrenProps = {
  children: React.ReactNode
}

export type JsxChildrenProps = {
  children: JSX.Element
}

export const GlobalStyles = ({ children }: JsxChildrenProps) => {
  return children
}
